import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {BaseObject} from "@/common/BaseObject";
import {Schema} from "@/common/Schema";

export class AudienceModel extends BaseObject {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(AudienceModel, v) : SKIP;
            },
            (v) => {
                return deserialize(AudienceModel, v);
            }
        );
    }

    constructor(name = '', percent = 0, users = 0) {
        super();
        this._name = name;
        this._percent = percent;
        this._users = users;
    }

    getColor(){
        //abcdefghijklmnopqrstuvwxyz
        switch (this._name){
            case 'a':return '#F44336'
            case 'b':return '#E91E63'
            case 'c':return '#673AB7'
            case 'd':return '#3F51B5'
            case 'e':return '#2196F3'
            case 'f':return '#00BCD4'
        }
        return '#607D8B'
    }

    get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }

    get percent() {
        return this._percent;
    }
    set percent(value) {
        this._percent = value;
    }

    get users() {
        return this._users;
    }
    set users(value) {
        this._users = value;
    }

    copy() {
        return super.copy();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new AudienceModel());
        } else if (target instanceof AudienceModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(AudienceModel, {
    _name: alias("name", Schema.primitive()),
    _percent: alias("percent", Schema.primitive()),
    _users: alias("users", Schema.primitive()),
});